import AspediaCRMGrid from './AspediaCRMGrid.vue'
import AspediaCRMGridApp from './AspediaCRMGridApp.vue'

import { LicenseManager } from '@ag-grid-enterprise/core'

import emailRenderer from './components/cellRenderer/email.vue'
import numberRenderer from './components/cellRenderer/number.vue'
import dateRenderer from './components/cellRenderer/date.vue'
import addressRenderer from './components/cellRenderer/address.vue'
import paragraphRenderer from './components/cellRenderer/paragraph.vue'
import phoneRenderer from './components/cellRenderer/phone.vue'
import actionsRenderer from './components/cellRenderer/actions.vue'
import textRenderer from './components/cellRenderer/text.vue'
import booleanRenderer from './components/cellRenderer/boolean.vue'
import enumRenderer from './components/cellRenderer/enum.vue'
import loadingCellRenderer from './components/cellRenderer/loadingCell.vue'

import 'ag-grid-community/dist/styles/ag-grid.css'
import 'ag-grid-community/dist/styles/ag-theme-alpine.css'

const install = (Vue, options) => {
  console.log(`Aspedia CRM Grid Support __buildVersion__ : Build date: __buildDate__`)

  if (Object.prototype.hasOwnProperty.call(options, 'license')) {
    LicenseManager.setLicenseKey(options.license)
  }

  Vue.component('emailRenderer', emailRenderer)
  Vue.component('dateRenderer', dateRenderer)
  Vue.component('addressRenderer', addressRenderer)
  Vue.component('paragraphRenderer', paragraphRenderer)
  Vue.component('phoneRenderer', phoneRenderer)
  Vue.component('actionsRenderer', actionsRenderer)
  Vue.component('textRenderer', textRenderer)
  Vue.component('booleanRenderer', booleanRenderer)
  Vue.component('enumRenderer', enumRenderer)
  Vue.component('numberRenderer', numberRenderer)
  Vue.component('loadingCellRenderer', loadingCellRenderer)

  Vue.component('aspediacrm-grid', AspediaCRMGrid)
  Vue.component('aspediacrm-grid-app', AspediaCRMGridApp)
}

export { install }

export default { install, AspediaCRMGrid, AspediaCRMGridApp }
